const ReportTemplate = `
  id
  createdAt
  meta
  name
  updatedAt
`;

export default ReportTemplate;
